export type SumberIcon = "lucide" | "upload" | "simpleicon" | "svg"

const TAG_DIIZINKAN = new Set(["svg", "g", "path", "circle", "ellipse", "rect", "line", "polyline", "polygon"])

const TAG_METADATA = new Set(["title", "desc", "metadata"])

const ATRIBUT_DIIZINKAN = new Set([
  "viewBox",
  "fill",
  "stroke",
  "stroke-width",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "fill-rule",
  "clip-rule",
  "opacity",
  "fill-opacity",
  "stroke-opacity",
  "transform",
  "d",
  "cx",
  "cy",
  "r",
  "rx",
  "ry",
  "x",
  "y",
  "x1",
  "y1",
  "x2",
  "y2",
  "points",
  "width",
  "height",
])

const ATRIBUT_DIBUANG_DI_AKAR = new Set(["width", "height", "x", "y"])
const POLA_TAG = /<\s*(\/)?\s*([a-zA-Z][a-zA-Z0-9]*)((?:\s+[^<>]*?)?)\s*(\/)?>/g
const POLA_ATRIBUT = /([a-zA-Z_:][-a-zA-Z0-9_:.]*)\s*=\s*(?:"([^"]*)"|'([^']*)')/g
const POLA_NILAI_AMAN = /^[-a-zA-Z0-9\s.,#%()+:;_/]*$/
const POLA_BERBAHAYA = /javascript:|data:|expression\s*\(|url\s*\(|@import|&#|<|>/i

export const MAKS_PANJANG_SVG = 24000
export const MAKS_NODE_SVG = 400

function nilaiAman(nilai: string): boolean {
  return POLA_NILAI_AMAN.test(nilai) && !POLA_BERBAHAYA.test(nilai)
}

function rangkaiAtribut(atribut: Map<string, string>): string {
  return Array.from(atribut.entries())
    .map(([nama, nilai]) => ` ${nama}="${nilai}"`)
    .join("")
}

function bacaAtribut(mentah: string, akar: boolean): Map<string, string> | null {
  const hasil = new Map<string, string>()

  for (const cocok of mentah.matchAll(POLA_ATRIBUT)) {
    const nama = cocok[1]
    const nilai = (cocok[2] ?? cocok[3] ?? "").trim()

    if (!ATRIBUT_DIIZINKAN.has(nama)) continue
    if (akar && ATRIBUT_DIBUANG_DI_AKAR.has(nama)) continue
    if (!nilaiAman(nilai)) return null
    hasil.set(nama, nilai)
  }

  return hasil
}

export function bersihkanSvgIkon(masukan: string): string | null {
  if (typeof masukan !== "string") return null
  const sumber = masukan.trim()
  if (!sumber || sumber.length > MAKS_PANJANG_SVG * 3) return null
  if (/<\s*(script|style|foreignObject|image|use|iframe|object|embed|link|animate|set)\b/i.test(sumber)) return null

  const keluaran: string[] = []
  const tumpukan: string[] = []
  let adaAkar = false
  let jumlahBentuk = 0
  let jumlahNode = 0

  for (const cocok of sumber.matchAll(POLA_TAG)) {
    const penutup = cocok[1] === "/"
    const tag = cocok[2]
    const tagKecil = tag.toLowerCase()
    const tutupSendiri = cocok[4] === "/"

    if (TAG_METADATA.has(tagKecil)) continue
    if (!TAG_DIIZINKAN.has(tagKecil)) return null

    jumlahNode += 1
    if (jumlahNode > MAKS_NODE_SVG) return null

    if (penutup) {
      if (tumpukan.pop() !== tagKecil) return null
      keluaran.push(`</${tagKecil}>`)
      continue
    }

    const akar = tagKecil === "svg"
    if (akar && adaAkar) return null
    if (!akar && !adaAkar) return null

    const atribut = bacaAtribut(cocok[3] ?? "", akar)
    if (!atribut) return null

    if (akar) {
      adaAkar = true
      atribut.set("xmlns", "http://www.w3.org/2000/svg")
      if (!atribut.has("viewBox")) return null
    } else if (tagKecil !== "g") {
      jumlahBentuk += 1
    }

    keluaran.push(`<${tagKecil}${rangkaiAtribut(atribut)}${tutupSendiri ? "/>" : ">"}`)
    if (!tutupSendiri) tumpukan.push(tagKecil)
  }

  if (!adaAkar || tumpukan.length > 0 || jumlahBentuk === 0) return null

  const hasil = keluaran.join("")
  return hasil.length <= MAKS_PANJANG_SVG ? hasil : null
}
